import React, { memo } from "react";
import { useTranslation } from "react-i18next";

const NoImagePlaceholder: React.FC = memo(() => {
  const { t } = useTranslation();
  
  return (
    <div className="no-image-placeholder">
      <svg
        width="80"
        height="60"
        viewBox="0 0 80 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="5"
          y="5"
          width="70"
          height="50"
          rx="4"
          stroke="#E7E4D8"
          strokeWidth="2"
          fill="#F7F6EF"
        />
        <path d="M20 20L30 35L45 20L60 45H20V20Z" fill="#E7E4D8" />
        <circle cx="30" cy="25" r="4" fill="#E7E4D8" />
      </svg>
      <p>{t("cleanup.noImages")}</p>
    </div>
  );
});

NoImagePlaceholder.displayName = "NoImagePlaceholder";

export default NoImagePlaceholder;
